import React, { Component } from 'react'
import CustomModal from '../../common/modal'
import Axios from 'axios'
import { Notifications } from '../../common/notification';
import { getUser } from '../../../actions/session'
import { GATEWAY_LISTING ,GATEWAY_DELETE, LOGIN_URL} from '../../../config/rest_endpoints'
import CustomLoader from '../../common/loader'
import AddGateway from './addGateway'
import UpdateGateway from './updateGateway';
import { Redirect } from 'react-router-dom';


class GatewayTable extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isModal:false,
            gatewayTable:[],
            User:getUser(),
            isGetting:false,
            id:this.props.userId,
            isDel:false,
            isEdit:false,
            delData:{},
            editData:{},
            isLoginURL: false
        }
        this.openModal = this.openModal.bind(this)
        this.closeModal = this.closeModal.bind(this)
        this.getGetwayList = this.getGetwayList.bind(this)
        this.delOpenModal = this.delOpenModal.bind(this)
        this.delCloseModal = this.delCloseModal.bind(this)
        this.editOpenModal = this.editOpenModal.bind(this)
        this.editCloseModal = this.editCloseModal.bind(this)
        this.deleteGateway = this.deleteGateway.bind(this)
        this.getGetwayList = this.getGetwayList.bind(this)
    }

    openModal() {
        this.setState({isModal:true})
    }
    
    closeModal() {
        this.setState({isModal:false})
    }

    delOpenModal(data) {
       console.log('data :>> ', data);
        this.setState({
            isDel:true,
            delData:data
        })
    }

    delCloseModal() {
        this.setState({isDel:false})
    }

    editOpenModal(data) {
        console.log('data', data)
        this.setState({isEdit:true, editData:data})
    }

    editCloseModal() {
        this.setState({isEdit:false},() => {
       
        })
    }

    componentDidMount() {
        this.getGetwayList()
    }

    getGetwayList() {
        const {User,id} = this.state
        console.log(' id:>> ',id );
        this.setState({isGetting:true})
        var headers = { "Authorization": "Bearer " + User.token };
        Axios.get(`${GATEWAY_LISTING}/${id}/gateway?page=1&limit=50`, { headers }).then(res => {
            if (res) {
                var resp = res.data.data
                console.log('resp :>> ', resp);
                this.setState({
                  gatewayTable:resp,
                isGetting: false
                })
            } else {

            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.setState({ isLoginURL: true })
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false,
            })
        })
    }

    deleteGateway() {
        const {User,delData} = this.state
        this.setState({isGetting:true})
        var headers = { "Authorization": "Bearer " + User.token };
        Axios.delete(`${GATEWAY_DELETE}/${delData['id']}/delete`, { headers }).then(res => {
            if (res) {
                var resp = res.data
                this.setState({isGetting:false})
                Notifications.notify(resp.message, "Deleted", "success")
                this.delCloseModal()
                this.getGetwayList()
            } else {

            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.setState({ isLoginURL: true })
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false,
            })
        })
      
    }

    renderGatewayList() {
        const {gatewayTable} = this.state
        if(gatewayTable === null || gatewayTable === undefined){
            return (
                <div className="ml-4 mt-2">
                    <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                    <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                </div>
            )
        }
        else{
            return gatewayTable.map((row,idx)=>{
                return(
                    <tr key={idx}>
                        <td style={{textAlign:'center'}}>{row.ip}</td>
                        <td style={{textAlign:'center'}}>{row.port}</td>
                    <td style={{textAlign:'center'}}>{row.sessions}</td>
                    <td style={{textAlign:'center'}}>{row['cps']}</td>
                    <td style={{textAlign:'center'}}>{row['prefix'] == '' ? 'N/A' : row['prefix']}</td>
                    <td style={{textAlign:'center'}}>{row.status === false ? <span className="badge badge-danger">Suspend</span> : <span className="badge badge-success">Active</span>}</td>
                    <td className='edit-button'><i className=" fa fa-edit mr-2" onClick={this.editOpenModal.bind(this,row)} ></i><i className="text-danger fa fa-trash" aria-hidden="true" onClick={this.delOpenModal.bind(this,row)} ></i></td>
                </tr>
                )
            })
        }
    }

    render() {
        const {isModal, isGetting,isDel,isEdit,delData} = this.state
        let addGatewaysModal = {
            details: {
                info: `Add Gateway`,
                msg: <AddGateway ID={this.state.id} listing={this.getGetwayList} close={this.closeModal} />
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeModal },
            cancelBtn: { label: "Cancel", action: this.closeModal }
        }

        let delGatewaysModal = {
            details: {
                info: `Delete`,
                msg: (<div>
                    <div class="modal-body">
                        <h4>Are you sure want to delete {delData.sipURL} ? </h4>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" onClick={this.delCloseModal} data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-danger" onClick={this.deleteGateway}>Confirm</button>
                    </div>
                </div>)
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.delCloseModal },
            cancelBtn: { label: "Cancel", action: this.delCloseModal }
        }

        let editGatewaysModal = {
            details: {
                info: `Edit ${this.state.editData.ip} `,
                msg:<UpdateGateway tabId={ this.state.id} close= {this.editCloseModal} syncList={this.getGetwayList} previousData={this.state.editData} />
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.editCloseModal },
            cancelBtn: { label: "Cancel", action: this.editCloseModal }
        }
        if (this.state.isLoginURL === true) {
            return <Redirect to={LOGIN_URL} ></Redirect>
        }
        return (
            <div>
                 <CustomModal
                    visibility={isModal}
                    customBodyCSS={"h20"}
                    modalType={"success"}
                    details={addGatewaysModal.details}
                    showBtns={false}
                    cancelBtn={addGatewaysModal.cancelBtn}
                    crossBtn={addGatewaysModal.crossBtn}
                />
                 <CustomModal
                    visibility={isDel}
                    customBodyCSS={"h20"}
                    modalType={"success"}
                    details={delGatewaysModal.details}
                    showBtns={false}
                    cancelBtn={delGatewaysModal.cancelBtn}
                    crossBtn={delGatewaysModal.crossBtn}
                />
                 <CustomModal
                    visibility={isEdit}
                    customBodyCSS={"h20"}
                    modalType={"success"}
                    details={editGatewaysModal.details}
                    showBtns={false}
                    cancelBtn={editGatewaysModal.cancelBtn}
                    crossBtn={editGatewaysModal.crossBtn}
                />
                <div style={{border:'none',borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.08)'}} className="card card-body  ">
                    <div className="card-header header-elements-inline p-0 py-1 mb-2">
                        <h4 style={{fontWeight:'700',fontSize:'24px'}} className="card-title"></h4>
                        <div className="header-elements">
                            <button type="submit" className="main-button btn btn-sm btn-success " onClick={this.openModal} >Add Gateway <i className="fas fa-plus ml-2"></i></button>
                        </div>
                    </div>
                    <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                        <div className="datatable-header">
                            <div id="DataTables_Table_0_filter" className="dataTables_filter">
                                {/* <label><span>Filter:</span>
                                    <input type="search" className="" placeholder="Type to filter..."  aria-controls="DataTables_Table_0" />
                                </label> */}
                            </div>
                        </div>
                        <div className="datatable-scroll" style={{ overflowX: 'auto'}}>
                            <table style={{border:'1px solid #ddd',borderCollapse:'collapse'}} className="table table-striped  no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                <thead>
                                    <tr className="stickeyHeader">
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>IP</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Port</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Session</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>CPS</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Prefix</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Status</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isGetting ? <CustomLoader /> : this.renderGatewayList()}
                                </tbody>
                            </table>
                        </div>
                        {/* <div className="datatable-footer">
                            <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 1 to 10 of 15 entries</div>
                            <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                        </div> */}
                    </div>
                </div>
            </div>
        )
    }
}
export default GatewayTable